import { render } from "./AccountPayable.vue?vue&type=template&id=8563ab7c&scoped=true"
import script from "./AccountPayable.vue?vue&type=script&lang=js"
export * from "./AccountPayable.vue?vue&type=script&lang=js"

import "./AccountPayable.vue?vue&type=style&index=0&id=8563ab7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8563ab7c"]])

export default __exports__